import SJNoData from '@/components/SJNoData'
import { getRegistration } from '@/services/accredit'
import { ExaminationState, Registration, RegistrationListRes } from '@/services/types/accredit'
import { useEffect, useRef, useState } from 'react'
import icons from '@/assets/icons'
import './index.less'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { InfiniteScroll, PullToRefresh } from 'antd-mobile'

// type State = {
//   playerId: string
// }
const RegistrationList = () => {
  document.title = '评测报名'
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const playerId = searchParams.get('playerId')
  const [registrations, setRegistrations] = useState<Registration[]>([])
  const pageRef = useRef(1)
  const sizeRef = useRef(10)
  const [hasMore, setHasMore] = useState(true)

  useEffect(() => {
    getRecords()
  }, [])

  const getRecords = async (page = 1, size = sizeRef.current) => {
    if (!playerId) return

    try {
      const res = (await getRegistration({
        applicant_id: playerId,
        // broker_id: ''
        page,
        size,
      })) as unknown as RegistrationListRes
      if (res.page === 1) {
        setRegistrations(res.registrations)
      } else {
        setRegistrations(registrations.concat(res.registrations))
      }
      setHasMore(res.page < res.page_total)
    } catch (error) {
      // console.error(error)
    }
  }

  const fetchMore = async () => {
    hasMore && (await getRecords(pageRef.current + 1))
  }

  const goResult = (item: Registration) => {
    // accredit.applicant_result = item
    // Taro.navigateTo({
    //   url: '/packageAccredit/pages/result/index?id=' + item.id,
    // })
    navigate(`/registration/result?id=${item.id}&from=list`)
  }

  const GradeIcon = (grade: number) => {
    return icons[`IconGrade${grade || 16}`]
  }

  const showRegisterNumber = (state: string) => {
    return ['paid', 'examining', 'examined', 'failed'].includes(state)
  }

  return (
    <div className="registration-list">
      <PullToRefresh onRefresh={getRecords}>
        <div className="main">
          <div className="register-list">
            {registrations.map((item: Registration) => (
              <div className="list-item hoverClass" key="index" onClick={() => goResult(item)}>
                <img className="grade" src={GradeIcon(item.applying_for_grade)} alt="" />
                <div className="info">
                  <div className="name oneline">{item.applicant_name}</div>
                  <div className="number oneline">
                    准考证号：
                    {showRegisterNumber(item.examination_state) ? item.registration_num : '***'}
                  </div>
                </div>
                <span className={`status status-${item.examination_state}`}>
                  {ExaminationState[item.examination_state]}
                </span>
              </div>
            ))}
            {registrations.length ? (
              // <div className="has-more">{hasMore ? '上滑加载更多' : '到底了'}</div>
              <InfiniteScroll loadMore={fetchMore} hasMore={hasMore}></InfiniteScroll>
            ) : (
              <SJNoData />
            )}
          </div>
        </div>
      </PullToRefresh>
    </div>
  )
}

export default RegistrationList
